import Vue from "vue";

// axios
import axios from "axios";
let auth = "";
if (localStorage.getItem("token")) {
  auth = "Bearer " + localStorage.getItem("token");
}

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: "https://api.showattack.tmss-repo.com/public/api",
  // baseURL: 'https://api.showattack.co.uk/public/api',

  baseURL: 'https://api.showattack.systemstailormade.com/api/',

  // baseURL: "http://127.0.0.1:8000/api",

  headers: { Authorization: "Bearer " + localStorage.getItem("token") },
});

/*
axiosIns.defaults.headers.post["Content-Type"] = "*";
axiosIns.defaults.headers.post["Access-Control-Allow-Origin"] = "*";
axiosIns.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded";
*/

// The staff-list endpoints answer 409 double_booking when someone on the
// submitted team already holds a job on one of those dates. It is handled here
// rather than at each call site: the planner dispatches these from a dozen
// places, most of which only `console.log` their errors, so a refused save would
// otherwise look like nothing happened at all.
//
// The planner is free to ignore all of this and set allowDoubleBooking itself,
// in which case the server never raises the 409.
const doubleBookingConfirm = (clashes) => {
  const lines = clashes
    .map(
      (c) =>
        "<li>" +
        c.person +
        " - already on " +
        (c.location || "another job") +
        " (" +
        c.date +
        ")</li>"
    )
    .join("");

  return Vue.swal({
    title: "Already booked",
    html:
      "<p>These people already have a job on the dates you are saving:</p><ul style='text-align:left'>" +
      lines +
      "</ul><p>Book them on this job as well?</p>",
    icon: "warning",
    showCancelButton: true,
    confirmButtonText: "Book anyway",
    cancelButtonText: "Cancel",
  }).then((result) => result && result.isConfirmed);
};

axiosIns.interceptors.response.use(
  (response) => response,
  (error) => {
    const response = error.response;
    const data = response && response.data;

    if (response && response.status === 409 && data && data.error === "double_booking") {
      // Retrying needs Vue.swal, which only exists once the sweetalert plugin
      // has registered. Without it, surface the refusal rather than silently
      // dropping the save.
      if (typeof Vue.swal !== "function") {
        return Promise.reject(error);
      }

      return doubleBookingConfirm(data.clashes || []).then((confirmed) => {
        if (!confirmed) {
          return Promise.reject(error);
        }

        const retry = { ...error.config };

        // Same request, this time stating that the overlap is intended. The
        // body is a JSON string for the POST endpoints; anything else (a legacy
        // GET, a form encoding) gets the flag as a query parameter instead.
        let flagged = false;

        if (typeof retry.data === "string" && retry.data.length > 0) {
          try {
            const body = JSON.parse(retry.data);
            body.allowDoubleBooking = 1;
            retry.data = JSON.stringify(body);
            flagged = true;
          } catch (e) {
            flagged = false;
          }
        }

        if (!flagged) {
          retry.params = { ...(retry.params || {}), allowDoubleBooking: 1 };
        }

        return axiosIns.request(retry);
      });
    }

    if (
      response &&
      response.status === 422 &&
      data &&
      (data.error === "teamList_missing" || data.error === "teamList_invalid")
    ) {
      if (typeof Vue.swal === "function") {
        Vue.swal({
          title: "Staff list not saved",
          text: data.message,
          icon: "error",
        });
      }
    }

    return Promise.reject(error);
  }
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
